<div class="media-box">
  <img class="bigimg slot-a"
       [class.active]="activeSlot === 'a'"
       [src]="imageUrlA"
       alt="" />
  <img class="bigimg slot-b"
       [class.active]="activeSlot === 'b'"
       [src]="imageUrlB"
       alt="" />

  @if (images.length > 1) {
    <div class="arrows">
      <mat-icon svgIcon="cm:previous"></mat-icon>
      <mat-icon svgIcon="cm:next"></mat-icon>
    </div>
  }

  @if (images.length > 1) {
    <div class="counter">
      {{ currentImageIndex + 1 }} {{ "IMAGE_VIEWER_OF" | translate }} {{ images.length }}
    </div>
  }

  <div class="timestamp">
    {{ currentImage.created | date: "dd/MM/yy" }} {{ "IMAGE_VIEWER_AT" | translate }}  {{ currentImage.created | date: "h:mma" }}
  </div>
</div>
